<template>
    <div class="tit-wrap centered">
        <small>INTRODUCE US</small>
        <h2 class="text-60 text-lg-50 text-md-34">사업개요</h2>
    </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.centered {
    text-align: center !important;
    margin-bottom: 2rem;

    &::before {
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>
